(() => {
  function setFullHeight() {
    const realHeight = window.innerHeight + 'px';
    document.documentElement.style.height = realHeight; // html
    document.body.style.height = realHeight;            // body
  }

  window.addEventListener('resize', setFullHeight);
  window.addEventListener('orientationchange', setFullHeight);
  window.addEventListener('load', setFullHeight);
  setFullHeight(); // gọi lần đầu

})();